import Http from '../Http'
import { IQuery } from '../interfaces/Query'
import { Routes } from '../routes'

export default class CreditRecords extends Http {
  public async list(token: string, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'get',
      Routes.creditRecordsPath(),
      token,
      params,
    )) as any
  }
}
